import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { Router } from '@angular/router';
import { GlobalserviceService } from './../globalservice.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Http, Headers } from '@angular/http';
import { RequestOptions, RequestMethod } from '@angular/http';

@Component({
  selector: 'app-generateqrcode',
  templateUrl: './generateqrcode.component.html',
  styleUrls: ['./generateqrcode.component.css']
})
export class GenerateqrcodeComponent implements OnInit {
  user;
  data;
  [x: string]: any;
  constructor(
    public globalservice: GlobalserviceService,
    private http: HttpClient,
    private router: Router, public snackBar: MatSnackBar) {

  }

  ngOnInit() {
    this.user = {};
    this.data = {};
  }
  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 3000,
    });
  }
  generate(mydata) {
    this.globalservice.qrdata(mydata).subscribe(responsedata => {

      debugger;
      if (responsedata.Success) {
        this.data = responsedata['Data'];
        this.snackBar.open('QR code is generated', '', { duration: 3000 });
        localStorage.setItem('EMP_ID', mydata['EMP_ID']);
        localStorage.setItem('qr_url', this.globalservice.base_url + responsedata['Data1']);
        this.router.navigate(['/qrcode']);

      }
      else {
        this.reason = responsedata["Message"];
        this.snackBar.open(this.reason, '', { duration: 3000 });
      }

    }, err => {
      alert("Error Occured");
    });

  }

}
